import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  required,
  useNotify,
  useRefresh,
  useRedirect,
} from 'react-admin';

const CategoryCreate = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = (data: any) => {
    notify('Категория создана успешно', { type: 'success' });
    refresh(); // Обновляем кеш данных
    redirect('list', 'categories/admin');
  };

  return (
    <Create mutationOptions={{ onSuccess }}>
      <SimpleForm>
      <TextInput
        source="name"
        label="Название"
        validate={[required()]}
        fullWidth
      />
      <TextInput
        source="slug"
        label="Слаг"
        validate={[required()]}
        fullWidth
        helperText="Уникальный идентификатор для URL (например: sushi, pizza)"
      />
      <TextInput
        source="description"
        label="Описание"
        multiline
        fullWidth
      />
      <NumberInput
        source="sortOrder"
        label="Порядок сортировки"
        defaultValue={0}
        helperText="Чем меньше число, тем выше в списке"
      />
      <BooleanInput
        source="isActive"
        label="Активна"
        defaultValue={true}
      />
      </SimpleForm>
    </Create>
  );
};

export default CategoryCreate;
